import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import type { BreakpointsKeys, Colors } from '@/theme/types';

export const Wrapper = styled(Flex)<{
  $maxWidth: BreakpointsKeys;
}>`
  ${({ $maxWidth, theme: { media } }) =>
    $maxWidth &&
    css`
      padding: 2rem;

      ${media[$maxWidth].down} {
        flex-direction: column;
        align-items: center;
        padding: 0;
      }
    `}
`;

export const ImageContainer = styled.div`
  max-width: 11rem;
`;

export const ProductImage = styled.img`
  width: 100%;
  height: auto;
  display: inline-block;
`;

export const ProductDescription = styled(Flex)<{
  $maxWidth: BreakpointsKeys;
}>`
  ${({ $maxWidth, theme: { media } }) =>
    $maxWidth &&
    css`
      flex-direction: column;
      justify-content: center;
      gap: 1.25rem;
      flex-grow: 1;

      ${media[$maxWidth].down} {
        justify-content: flex-start;
      }
    `}
`;

export const Heading = styled(Typography)`
  width: 100%;
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      text-align: left;
    }
  `}
`;

export const Collection = styled(Typography)<{
  color: keyof Colors;
}>`
  font-size: inherit;
  line-height: inherit;
  ${({ color, theme }) => css`
    color: ${theme.colors[color as keyof Colors]};
  `}
`;
